import React, { useEffect, useRef } from 'react';
import '../css/Environment.css';

const values = [
  {
    icon: '🧠',
    title: 'AI with Integrity',
    description: 'Our AI tools support businesses in branding, automation, and content — always with ethical guardrails, transparency, and context-awareness.'
  },
  {
    icon: '🎯',
    title: 'Brand Discipline',
    description: 'We enable businesses to standardize creative systems, maintain consistency, and scale communication with clarity.'
  },
  {
    icon: '♻️',
    title: 'Sustainable Digital Footprint',
    description: 'We prioritize lean design, low-bloat code, and minimalist frontend systems that reduce digital clutter and energy consumption.'
  },
  {
    icon: '🤝',
    title: 'Transparent Collaboration',
    description: 'We power seamless sharing and collaborative workflows across teams, clients, and partners.'
  },
  {
    icon: '📦',
    title: 'Build Once, Scale Everywhere',
    description: 'Red Fibre lets you create once and deploy across campaigns, teams, and platforms efficiently.'
  },
  {
    icon: '🌍',
    title: 'Inclusive Tech, Global Thinking',
    description: 'Our systems support multilingual inputs, remote teams, and cultural nuance.'
  }
];

const Environment = () => {
  const valuesGridRef = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
    const valueCards = valuesGridRef.current?.querySelectorAll('.value-card');
    const environmentalSection = document.querySelector('.environmental-section');
    
    if (!valueCards) return;

    const onChange = (changes) => {
      changes.forEach(change => {
        const target = change.target;
        if (change.isIntersecting) {
          target.classList.add('is-visible');
        } else {
          target.classList.remove('is-visible');
        }
      });
    };

    observerRef.current = new IntersectionObserver(onChange, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });

    // Observe all value cards
    valueCards.forEach(card => {
      observerRef.current.observe(card);
    });

    // Also observe the environmental section
    if (environmentalSection) {
      observerRef.current.observe(environmentalSection);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <div className="values-page">
      <div className="header-section">
        <h1 className="main-title">Red Fibre Values</h1>
        <p className="subtitle">
          Red Fibre is a creative operating system for businesses who care about branding, culture, and ethics in the digital era.
        </p>
      </div>
      
      <div ref={valuesGridRef} className="values-grid">
        {values.map((v, i) => (
          <div key={i} className="value-card">
            <div className="value-icon">{v.icon}</div>
            <h3 className="value-title">{v.title}</h3>
            <p className="value-description">{v.description}</p>
          </div>
        ))}
      </div>
      
      <div className="environmental-section">
        <h2 className="environmental-title">Our Environmental Promise</h2>
        <p className="environmental-description">
          We advocate for lightweight code, fewer dependencies, and mindful design — acknowledging our digital carbon footprint.
        </p>
      </div>
    </div>
  );
};

export default Environment;